"use strict";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import {
  Form,
  Row,
  Col,
  InputNumber,
  Input,
  Button,
  Spin,
  Divider,
  Modal,
  Typography,
  Select,
  Table,
  Tooltip,
  ConfigProvider,
  BackTop,
  Checkbox,
  Progress,
  Space,
} from "antd";
import { database } from "../services/database.service";
import { userService } from "../services";
import "./register-files";
import { FilePdfOutlined } from "@ant-design/icons";
const textoIconExportarPDF = <span>Imprimir Recetas PDF</span>;
import { PlantillasRecetas } from "../utility/plantillasRecetas";
const { Title } = Typography;
import {
  ONFINISH_BUSCAR_RECETAS_MENUS,
  IMPRIMIR_RECETAS_MENU_COLUMNS,
} from "../utility/constants";
import CustomizeRenderEmpty from "../components/CustomizeRenderEmpty";

class ImprimirRecetasMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
      users: [],
      redirecting: false,
      loading: false,
      iconLoading: false,
      employee: {},
      employees: [],
      options: [],
      listaOptionsEstadosMenus: [],
      optionsEstadosMenu: [],
      statusListaEstadosMenus: null,
      optionsCentrosUsuarios: [],
      usuario: null,
      resultadoBusquedaPorPlato: [],
      statusResultadoBusquedaPorPlato: null,
      letallowClearDieta: true,
      statusValueEstadoMenu: null,
      statusValueNomMenu: null,
      statusValueCodMenu: null,
      filteredInfo: null,
      sortedInfo: null,
      exportarPlatosExcel: [],
      familiaSeleccionada: null,
      dietaSeleccionada: null,
      nombrePlato: null,
      selectedRows: [],
      selectedRowKeys: [],
      selectedRowsMenu: [],
      selectedRowKeysMenu: [],
      listaFotosRecetas: [],
      loadingSpingBuscarPlato: false,
      textoLoadingSpingBuscarPlato: "",
      visibleModalLogoRecetasMe100: false,
      visibleModalLogoRecetasMa100: false,
      valorSelectLogo: "",
      valorSelectPlantillaReceta: "",
      checkboxImprimirFamiliaPlato: false,
      checkboxImprimirPesoPlato: false,
      checkBoxGroupRecetasImprimir: [],
      checkAll: false,
      listaOptionsCatalogosUsuario: [],
      optionsCatalogosUsuario: [],
      checkboxImprimirImagenPlato: false,
      dataRecetasM100: [],
      visibleModalProgreso: false,
      porcientoModalProgreso: 25,
      listaIdiomas: [],
      statusListaIdiomas: "",
      valorSelectIdiomaActual: "525",
      selectCatalogo: "",
    };
  }

  /**
   * Sacame todo lo que tengas que sacar de la API antes de imprimir Pantalla Buscar Por Plato */
  componentWillMount() {
    this.setState({
      user: JSON.parse(localStorage.getItem("user")),
      users: { loading: true },
      employee: JSON.parse(localStorage.getItem("employee")),
      employees: { loading: true },
      isLoaded: true,
      loadingSpingBuscarPlato: true,
      textoLoadingSpingBuscarPlato:
        "Cargando pantalla para imprimir recetas por menú...",
      valorSelectIdiomaActual: "525",
    });

    this.getlistaOptionsEstadosMenus();
    this.getlistaOptionsCatalogosUsuario();
    this.getListaIdiomas();
  }

  /**
   Obtengo el listado de idiomas y actualizo el estado de los elementos
 */
  getListaIdiomas = () => {
    database.getIdiomas().then((res) => {
      this.setState({
        listaIdiomas: res.response,
        statusListaIdiomas: "success",
      });
    });
  };

  /**
      Obtengo el listado de catálogos del usuario y actualizo estado.
    */
  getlistaOptionsCatalogosUsuario = () => {
    database
      .getCatalogosUsuario(
        JSON.parse(localStorage.getItem("user")).sAMAccountName
      )
      .then((res) => {
        this.setState({
          listaOptionsCatalogosUsuario: res.response,
        });

        let resultadoCatalogoUsuario = [];
        for (
          let i = 0;
          i < this.state.listaOptionsCatalogosUsuario.length;
          i++
        ) {
          resultadoCatalogoUsuario.push({
            value: `${this.state.listaOptionsCatalogosUsuario[i].CATALOGO}`,
            label: `${this.state.listaOptionsCatalogosUsuario[i].NOMBRE}`,
          });
        }

        this.setState({
          optionsCatalogosUsuario: resultadoCatalogoUsuario,
          loadingSpingBuscarPlato: false,
          textoLoadingSpingBuscarPlato: "",
        });
      });
  };

  /**
    Obtengo el listado de estados de los menús y actualizo estado.
  */
  getlistaOptionsEstadosMenus = () => {
    database.getEstadosMenus().then((res) => {
      this.setState({
        listaOptionsEstadosMenus: res.response,
        statusListaEstadosMenus: "success",
      });

      let resultadoEstadosMenu = [];
      for (let i = 0; i < this.state.listaOptionsEstadosMenus.length; i++) {
        resultadoEstadosMenu.push({
          value: `${this.state.listaOptionsEstadosMenus[i].ID_ESTADO_MENU}`,
          label: `${this.state.listaOptionsEstadosMenus[i].NOMBRE}`,
        });
      }

      this.setState({ optionsEstadosMenu: resultadoEstadosMenu });
    });
  };

  /**
   * Recetear los campos del buscador al pinchar botón cancelar.
   * */
  handleReset = () => {
    this.props.form.resetFields();
    this.setState({
      statusValueEstadoMenu: null,
      statusValueNomMenu: null,
      statusValueCodMenu: null,
      loading: false,
      selectedRows: [],
      selectedRowKeys: [],
      selectedRowsMenu: [],
      selectedRowKeysMenu: [],
    });
  };

  /**
   * Manejar la paginación al mostrar el resultado de la busqueda de las recetas.
   * */
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  };

  /**
   * Verificar que el usurio tenga seleccionado el menú y mostrar el Modal dialogs
   * para que el usuario selecciones el logo que se debe imrimir en la plantilla de la etiqueta.
   */
  confirmacionImprimirRecetasPDF = () => {
    try {
      this.setState({
        selectedRowKeys: [],
        porcientoModalProgreso: 25,
      });

      if (this.state.selectedRowKeysMenu.length === 0) {
        Modal.warning({
          title: "Advertencia",
          content: "Debes seleccionar un menú para imprimir las recetas.",
        });
      } else {
        let listadoRecetasMenu = "null";
        let fechaServicio = "null";
        let tipoMenu = "null";
        let codMenu = this.state.selectedRowKeysMenu[0];
        /**
         * Obtengo el listado de recetas con sus datos dado el menú...
         */
          database
            .getImprimirRecetasMenu(
              codMenu.toString(),
              listadoRecetasMenu,
              fechaServicio,
              tipoMenu
            )
            .then(
              (valor) => {
                let listaRecetasMenuValores = valor.response;
                if (
                  listaRecetasMenuValores.status === "success" &&
                  listaRecetasMenuValores.message.length > 0
                ) {
                  let listaCodigoRecetasTabla = [];
                  let listaRecetasMenu = listaRecetasMenuValores.message;

                  for (let i = 0; i < listaRecetasMenu.length; i++) {
                    listaCodigoRecetasTabla.push({
                      key: listaRecetasMenu[i].CODIGO_RECETA,
                      cod_receta: listaRecetasMenu[i].CODIGO_RECETA,
                      nombre_receta: listaRecetasMenu[i].NCOMERCIAL_RECETA,
                      dec_alergenos:
                        listaRecetasMenu[i].DECLARACION_ALERGENOS ===
                        "INCOMPLETA" ? (
                          <span style={{ color: "#f3000c" }}>
                            {listaRecetasMenu[i].DECLARACION_ALERGENOS}
                          </span>
                        ) : (
                          listaRecetasMenu[i].DECLARACION_ALERGENOS
                        ),
                    });
                  }

                  this.setState({
                    visibleModalLogoRecetasMa100: true,
                    dataRecetasM100: listaCodigoRecetasTabla,
                  });
                } else if (
                  listaRecetasMenuValores.status === "success" &&
                  listaRecetasMenuValores.message.length === 0
                ) {
                  Modal.error({
                    title: "Error",
                    content: "El menú seleccionado no tiene recetas asociadas.",
                  });
                } else {
                  Modal.error({
                    title: "Error",
                    content:
                      "Ha ocurrido el siguiente error: " +
                      listaRecetasMenuValores.message,
                    onOk() {},
                  });
                }
              },
              (error) => this.setState({ error, loading: true })
            );
        
      }
    } catch (e) {
      Modal.error({
        title: "Error",
        content:
          "Ha ocurrido el siguiente error al Recuperar las recetas del Menú seleccionado: " +
          e +
          ". Contactar con el administrador.",
      });
    }
  };

  /**
   * Imprime las recetas seleccionadas por el usuario almacenadas en this.state.selectedRowKeys
   */
  imprimirRecetasPDF = () => {
    this.setState({ listaIngredientesRecetas: [] });

    let listaCodigoRecetas = this.state.selectedRowKeys;
    let fechaServicio = "null";
    let tipoMenu = "null";

    try {
      if (listaCodigoRecetas.length != 0 && listaCodigoRecetas.length <= 60) {
        /**
         * Obtengo el listado de recetas con sus datos dado el menú...
         */
          database
            .getImprimirRecetasMenu(
              this.state.selectedRowKeysMenu.toString(),
              listaCodigoRecetas.toString(),
              fechaServicio,
              tipoMenu
            )
            .then((valor) => {
              const listaRecetasMenuValores = valor.response;

              let listaRecetasMenu = listaRecetasMenuValores.message;
              let listaCodigoRecetas = [];

              const catalogoActual = this.state.selectCatalogo;
              const idiomaActual = this.state.valorSelectIdiomaActual;
              const valorSelectLogo = this.state.valorSelectLogo;
              const checkboxImprimirImagenPlato =
                this.state.checkboxImprimirImagenPlato;
              const checkboxImprimirFamiliaPlato =
                this.state.checkboxImprimirFamiliaPlato;
              const checkboxImprimirPesoPlato =
                this.state.checkboxImprimirPesoPlato;
              const tiempo = checkboxImprimirImagenPlato === true ? 2000 : 1000;
              const plantilla = this.state.valorSelectPlantillaReceta;

              listaRecetasMenu.forEach((receta) => {
                listaCodigoRecetas.push(receta.ID_RECETA);
              });
              /**
               * Recorro el JSON listaRecetasMenu para obtener solamente los códigos de las recetas para buscar sus ingredientes y fotos
               */

              if (listaRecetasMenuValores.status !== "success") {
                Modal.error({
                  title: "Error",
                  content:
                    "Ha ocurrido el siguiente error: " +
                    listaRecetasMenuValores.message,
                });
                this.setState({
                  visibleModalLogoRecetasMa100: true,
                });
              }

              if (
                listaRecetasMenuValores.status === "success" &&
                listaRecetasMenuValores.message.length === 0
              ) {
                Modal.error({
                  title: "Error",
                  content:
                    "El menú " +
                    this.state.selectedRowsMenu[0].ID_MENU +
                    "." +
                    this.state.selectedRowsMenu[0].NOM_MENU +
                    " no tiene recetas asignadas.",
                });
                this.setState({
                  visibleModalLogoRecetasMa100: true,
                });
              }

              if (
                listaRecetasMenuValores.status === "success" &&
                listaRecetasMenuValores.message.length > 0 &&
                plantilla === "plantilla-recetas-1"
              ) {
                //Plantilla Comercial
                PlantillasRecetas.imprimirRecetasPlantilla1(
                  catalogoActual,
                  listaCodigoRecetas.toString(),
                  idiomaActual,
                  valorSelectLogo,
                  checkboxImprimirImagenPlato,
                  checkboxImprimirFamiliaPlato,
                  checkboxImprimirPesoPlato
                );
              }

              if (
                listaRecetasMenuValores.status === "success" &&
                listaRecetasMenuValores.message.length > 0 &&
                plantilla === "plantilla-recetas-2"
              ) {
                //Plantilla Centros In Situ
                PlantillasRecetas.imprimirRecetasPlantilla2(
                  catalogoActual,
                  listaCodigoRecetas.toString(),
                  idiomaActual,
                  valorSelectLogo,
                  checkboxImprimirImagenPlato
                );
              }

              if (
                listaRecetasMenuValores.status === "success" &&
                listaRecetasMenuValores.message.length > 0 &&
                plantilla === "plantilla-recetas-3"
              ) {
                //Plantilla Centros Transportado
                if (listaCodigoRecetas.length <= 10) {
                  PlantillasRecetas.imprimirRecetasPlantilla3(
                    catalogoActual,
                    listaCodigoRecetas.toString(),
                    idiomaActual,
                    valorSelectLogo,
                    checkboxImprimirImagenPlato
                  );
                } else {
                  Modal.error({
                    title: "Error",
                    content: `Para la plantilla seleccionada solo puedes imprimir bloques de 10 recetas como mucho. Actualmente tiene seleccionadas ${listaCodigoRecetas.length} recetas.`,
                  });
                }
              }

              if (
                listaRecetasMenuValores.status === "success" &&
                listaRecetasMenuValores.message.length > 0 &&
                plantilla === "plantilla-recetas-4"
              ) {
                //Plantilla Cocina Central
                if (listaCodigoRecetas.length <= 10) {
                  PlantillasRecetas.imprimirRecetasPlantilla4(
                    catalogoActual,
                    listaCodigoRecetas.toString(),
                    idiomaActual,
                    valorSelectLogo,
                    checkboxImprimirImagenPlato
                  );
                } else {
                  Modal.error({
                    title: "Error",
                    content: `Para la plantilla seleccionada solo puedes imprimir bloques de 10 recetas como mucho. Actualmente tiene seleccionadas ${listaCodigoRecetas.length} recetas.`,
                  });
                }
              }

              if (
                listaRecetasMenuValores.status === "success" &&
                listaRecetasMenuValores.message.length > 0
              ) {
                setTimeout(() => {
                  this.setState({
                    loadingSpingBuscarPlato: false,
                    checkboxImprimirFamiliaPlato: false,
                    checkboxImprimirImagenPlato: false,
                    checkBoxListaCodigoRecetasOrdenadas: [],
                    visibleModalProgreso: false,
                  });
                }, tiempo * listaCodigoRecetas.length);
              }
            });
        
      } else {
        Modal.error({
          title: "Error",
          content:
            "Debe seleccionar como mínimo una receta para imprimir y como mucho 60 recetas a la vez.",
        });
        this.setState({
          visibleModalLogoRecetasMa100: true,
        });
      }
    } catch (e) {
      Modal.error({
        title: "Error",
        content:
          "Ha ocurrido el siguiente error al Imprimir las Fichas Técnicas: " +
          e +
          ". Contactar con el administrador.",
      });
      this.setState({
        loadingSpingBuscarPlato: false,
        textoLoadingSpingBuscarPlato: "",
        checkboxImprimirFamiliaPlato: false,
        checkboxImprimirImagenPlato: false,
        checkBoxListaCodigoRecetasOrdenadas: [],
        visibleModalProgreso: false,
        visibleModalSeletImpresionRecetas: false,
        porcientoModalProgreso: 25,
      });
    }
  };

  start = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({
        selectedRowKeys: [],
      });
    }, 1000);
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  onFinishBuscarRecetasMenus = (centro, nombreMenu, codigoMenu, estadoMenu) => {
    this.setState({ loadingSpingBuscarPlato: true });
    /**
     * Actualizo estados para mostrar Cargando datos hasta que termine de recuperar
     * y mostrar los datos
     */
    this.setState({
      loadingSpingBuscarPlato: true,
      textoLoadingSpingBuscarPlato: "Cargando datos...",
    });

    let centroSeleccionado = centro;
    let menuNombre = nombreMenu == null ? "null" : nombreMenu;
    let menuCodigo = codigoMenu == null ? "null" : codigoMenu;
    let estadoMenuSeleccionado = estadoMenu == null ? "null" : estadoMenu;

    this.setState({ loading: true });

    /**
     * Ejecuto la consulta para recuperar los menús
     */
      database
        .getMenus(
          centroSeleccionado,
          menuNombre,
          menuCodigo,
          estadoMenuSeleccionado
        )
        .then(
          (valor) => {
            const data = valor.response;

            const dataTabla = [];
            for (let i = 0; i < data.length; i++) {
              dataTabla.push({
                ID_MENU: data[i].ID_MENU,
                NOM_MENU: data[i].NOM_MENU,
                TIPO_ID: data[i].TIPO_ID,
                ID_TIPO_MENU: data[i].ID_TIPO_MENU,
                NOM_TIPO_MENU: data[i].NOM_TIPO_MENU,
                ESTADO_ID: data[i].ESTADO_ID,
                ID_ESTADO_MENU: data[i].ID_ESTADO_MENU,
                NOM_ESTADO_MENU: data[i].NOM_ESTADO_MENU,
                FECHA_INICIO:
                  data[i].FECHA_INICIO === null
                    ? " "
                    : data[i].FECHA_INICIO.substring(0, 10),
                FECHA_FIN:
                  data[i].FECHA_FIN === null
                    ? " "
                    : data[i].FECHA_FIN.substring(0, 10),
                CENTRO_ID: data[i].CENTRO_ID,
                letIACION: data[i].letIACION,
                VERSION: data[i].VERSION,
                VERSION_NUM: data[i].VERSION_NUM,
                DIETA_ID: data[i].DIETA_ID,
                USUARIO_CREACION: data[i].USUARIO_CREACION,
                FECHA_CAMBIO:
                  data[i].FECHA_CAMBIO === null
                    ? " "
                    : data[i].FECHA_CAMBIO.substring(0, 10),
                PERIODO: data[i].PERIODO,
                OBJETIVO: data[i].OBJETIVO,
                USUARIO_CAMBIO: data[i].USUARIO_CAMBIO,
                ID_ROL_CREACION: data[i].ID_ROL_CREACION,
                COSTE_OBJETIVO: data[i].COSTE_OBJETIVO,
                CENTRO_ID_let: data[i].CENTRO_ID_let,
                COMENTARIO_VERSION: data[i].COMENTARIO_VERSION,
                DETALLE: data[i].DETALLE,
                ID_let: data[i].ID_let,
                MES: data[i].MES,
                VERSION_ID: data[i].VERSION_ID,
                COSTE_MEDIO: data[i].COSTE_MEDIO,
                ROTATIVO: data[i].ROTATIVO,
                SERVICIO_FINDE: data[i].SERVICIO_FINDE,
                VERSION_CENTRO_ID: data[i].VERSION_CENTRO_ID,
                UNIDAD_MEDIDA: data[i].UNIDAD_MEDIDA,
                ID_CATALOGO: data[i].ID_CATALOGO,
                NOM_CATALOGO: data[i].NOM_CATALOGO,
                FECHA_INI_PRODUCCION:
                  data[i].FECHA_INI_PRODUCCION === null
                    ? " "
                    : data[i].FECHA_INI_PRODUCCION.substring(0, 10),
                FECHA_FIN_PRODUCCION:
                  data[i].FECHA_FIN_PRODUCCION === null
                    ? " "
                    : data[i].FECHA_FIN_PRODUCCION.substring(0, 10),
                COSTEANT: data[i].COSTEANT,
                SEMANA_CICLO: data[i].SEMANA_CICLO,
                COMENTARIO_ESTADO: data[i].COMENTARIO_ESTADO,
                ENPRODUCCIONFILTRO: data[i].ENPRODUCCIONFILTRO,
              });
            }

            const rowSelection = {
              onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                  selectedRowsMenu: selectedRows,
                  selectedRowKeysMenu: selectedRowKeys,
                });
              },
            };

            ReactDOM.render(
              <div>
                <ConfigProvider renderEmpty={CustomizeRenderEmpty}>
                  <Tooltip placement="topLeft" title={textoIconExportarPDF}>
                    <Button
                      size="default"
                      style={{
                        boxShadow: "0 0 0 0 rgba(0,123,255,.25)",
                        borderColor: "#fff",
                        border: 0,
                        backgroundColor: "#fff",
                      }}
                      onClick={this.confirmacionImprimirRecetasPDF}
                      type="dashed"
                    >
                      <FilePdfOutlined />
                    </Button>
                  </Tooltip>

                  <Table
                    rowSelection={{ type: "radio", ...rowSelection }}
                    rowKey={(record) => record.ID_MENU}
                    size={"small"}
                    columns={ONFINISH_BUSCAR_RECETAS_MENUS}
                    dataSource={dataTabla}
                    scroll={{ x: 1700, y: 900 }}
                    onChange={this.handleChange}
                  />
                </ConfigProvider>
              </div>,

              document.getElementById("infoBusquedaPorPlato")
            );

            this.setState({ loading: false, loadingSpingBuscarPlato: false });
          },
          (error) => this.setState({ error, loading: true })
        );
    
  };

  loadingSpingImprimirRecetas = () => {
    this.setState({
      loadingSpingBuscarPlato: true,
      textoLoadingSpingBuscarPlato: "Cargando datos...",
    });
  };

  onChangeStateMenu = (value) => {
    this.setState({
      statusValueEstadoMenu: "success",
    });
  };

  onChangeCodMenu = (e) => {
    const sd = e;
    if (sd === "") {
      this.setState({
        statusValueCodMenu: "null",
      });
    } else {
      this.setState({
        statusValueCodMenu: "success",
      });
    }
  };

  onChangeNameMenu = (e) => {
    const sd = e.target.value;
    if (sd === "") {
      this.setState({
        statusValueNomMenu: "null",
      });
    } else {
      this.setState({
        statusValueNomMenu: "success",
      });
    }
  };

  /**
   * Actualizo el estado con el valor de la plantilla seleccionada por el usuario.
   */

  onChangePlantillaReceta = (value) => {
    this.setState({
      valorSelectPlantillaReceta: value,
    });
  };

  /**
   * Imprimo Idioma seleccionado
   */
  onChangeIdiomas = (value) => {
    this.setState({
      valorSelectIdiomaActual: value,
    });
  };

  /**
   * Comprueba que se haya seleccionado un logo y lanzo la impresión de las recetas llamando a
   * la fucnión imprimirRecetasPDF y actualizo el estado de mantener vislible el Modal dialogs de los logos.
   */
  handleOkModalLogo = () => {
    if (
      (this.state.valorSelectLogo.length === 0 ||
        this.state.valorSelectPlantillaReceta.length === 0 ||
        this.state.valorSelectIdiomaActual.length === 0) &&
      this.state.selectedRowKeys.length > 0
    ) {
      Modal.error({
        title: "Error",
        content:
          "Te has dejado por seleccionar el logo o la plantilla o el idioma para imprimir la(s) recetas.",
      });
    } else if (
      this.state.valorSelectLogo.length > 0 &&
      this.state.selectedRowKeys.length === 0
    ) {
      Modal.error({
        title: "Error",
        content:
          "Debes seleccionar al menos una receta antes de lanzar la impresión.",
      });
    } else if (
      this.state.valorSelectLogo.length === 0 &&
      this.state.selectedRowKeys.length === 0 &&
      this.state.valorSelectPlantillaReceta.length === 0
    ) {
      Modal.error({
        title: "Error",
        content:
          "Debes seleccionar al menos una receta así como el logo y la plantilla antes de lanzar la impresión.",
      });
    } else {
      this.imprimirRecetasPDF();
    }
  };

  /**
   * Actualizo el estado de mantener vislible el Modal dialogs de los logos al usuario cancelar la acción.
   */
  handleCancelModalLogo = () => {
    this.setState({
      visibleModalLogoRecetasMe100: false,
      visibleModalLogoRecetasMa100: false,
      // listaRecetasMenuOrdenadas: [],
      selectedRowKeys: [],
      checkBoxListaCodigoRecetasOrdenadas: [],
    });
  };

  /**
   * Actualizo el estado con el valor del logo seleccionado por el usuario.
   */

  onChangeSelectLogo = (value) => {
    this.setState({
      statusValueFamilia: "success",
      valorSelectLogo: value,
    });
  };

  /**
   * Mostar checbox para imprimir o no la familia en la receta.
   */
  onChangeCheckboxImprimirFamiliaPlato = (e) => {
    let checkedGU = e.target.checked;
    this.setState({
      checkboxImprimirFamiliaPlato: checkedGU,
    });
  };

  /**
   * Mostar checbox para imprimir o no la imagen en la receta.
   */
  onChangeCheckboxImprimirImagenPlato = (e) => {
    let checkedGU = e.target.checked;

    this.setState({
      checkboxImprimirImagenPlato: checkedGU,
    });
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  /**
   * Mostar checkbox para imprimir o no el peso de la receta.
   */
  onChangeCheckboxImprimirPesoPlato = (e) => {
    let checkedGU = e.target.checked;

    this.setState({
      checkboxImprimirPesoPlato: checkedGU,
    });
  };

  render() {
    const { selectedRowKeys, dataRecetasM100 } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelectedM100 = selectedRowKeys.length > 0;

    const { Option } = Select;

    let resultadoEstadosMenu = [];
    for (let i = 0; i < this.state.listaOptionsEstadosMenus.length; i++) {
      resultadoEstadosMenu.push(
        <Select.Option
          key={this.state.listaOptionsEstadosMenus[i].ID_ESTADO_MENU}
          label={this.state.listaOptionsEstadosMenus[i].NOMBRE}
          title={this.state.listaOptionsEstadosMenus[i].NOMBRE}
        >
          {this.state.listaOptionsEstadosMenus[i].NOMBRE}
        </Select.Option>
      );
    }

    /**
     * Construyo el select con los idiomas que se van a mostrar en el select
     */
    let resultadoIdiomas = [];

    for (let i = 0; i < this.state.listaIdiomas.length; i++) {
      resultadoIdiomas.push(
        <Select.Option
          key={this.state.listaIdiomas[i].COD_IDIOMA}
          label={
            this.state.listaIdiomas[i].COD_IDIOMA +
            "." +
            this.state.listaIdiomas[i].DESC_IDIOMA
          }
          title={
            this.state.listaIdiomas[i].COD_IDIOMA +
            "." +
            this.state.listaIdiomas[i].DESC_IDIOMA
          }
        >
          {this.state.listaIdiomas[i].DESC_IDIOMA}
        </Select.Option>
      );
    }

    let resultadoCentros = [];

    for (let i = 0; i < this.state.listaOptionsCatalogosUsuario.length; i++) {
      resultadoCentros.push(
        <Select.Option
          key={this.state.listaOptionsCatalogosUsuario[i].CATALOGO}
          label={this.state.listaOptionsCatalogosUsuario[i].NOMBRE}
          title={this.state.listaOptionsCatalogosUsuario[i].NOMBRE}
        >
          {this.state.listaOptionsCatalogosUsuario[i].CATALOGO +
            "." +
            this.state.listaOptionsCatalogosUsuario[i].NOMBRE}
        </Select.Option>
      );
    }

    const {
      loadingSpingBuscarPlato,
      textoLoadingSpingBuscarPlato,
      selectedRowsMenu,
      visibleModalLogoRecetasMa100,
    } = this.state;

    const hasSelected = selectedRowsMenu.length > 0;

    const AdvancedSearchForm = () => {
      const [form] = Form.useForm();

      const onFinish = (values) => {
        this.setState({
          selectedRowKeysMenu: [],
          selectedRowsMenu: [],
        });

        let volresBuscarRecetas = Object.values(values);

        let selectCentro = volresBuscarRecetas[0];
        let inputNombreMenu = volresBuscarRecetas[1];
        let inputCodigoMenu = volresBuscarRecetas[2];
        let selectEstadoMenu = volresBuscarRecetas[3];

        if (
          inputNombreMenu != null ||
          inputCodigoMenu != null ||
          selectEstadoMenu != null
        ) {
          this.setState({
            selectCatalogo: selectCentro,
          });

          this.onFinishBuscarRecetasMenus(
            selectCentro,
            inputNombreMenu,
            inputCodigoMenu,
            selectEstadoMenu
          );
        } else {
          Modal.error({
            title: "Error",
            content: "Debes seleccionar otro criterio de búsqueda...",
          });
        }
      };

      return (
        <Form
          form={form}
          name="advanced_search"
          className="ant-advanced-search-form"
          onFinish={onFinish}
        >
          <Row gutter={8}>
            <Col
              xs={{ span: 12, offset: 1 }}
              lg={{ span: 5, offset: 1 }}
              style={{ float: "left" }}
            >
              <Form.Item
                name="select-Centro"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Campo obligatorio",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Seleccionar Catálogo"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {resultadoCentros}
                </Select>
              </Form.Item>
            </Col>

            <Col
              xs={{ span: 12, offset: 1 }}
              lg={{ span: 5, offset: 1 }}
              style={{ float: "left" }}
            >
              <Form.Item
                name="input-NombreMenu"
                hasFeedback
                rules={[
                  {
                    required: false,
                    message: "Campo no obligatorio",
                  },
                ]}
              >
                <Input placeholder="Nombre del menú" />
              </Form.Item>
            </Col>

            <Col
              xs={{ span: 12, offset: 1 }}
              lg={{ span: 5, offset: 1 }}
              style={{ float: "left" }}
            >
              <Form.Item
                name="input-CodigoMenu"
                hasFeedback
                rules={[
                  {
                    required: false,
                    message: "Campo no obligatorio",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="Código del menú"
                />
              </Form.Item>
            </Col>

            <Col
              xs={{ span: 12, offset: 1 }}
              lg={{ span: 5, offset: 1 }}
              style={{ float: "left" }}
            >
              <Form.Item
                name="select-EstadoMenu"
                hasFeedback
                rules={[
                  {
                    required: false,
                    message: "Campo no obligatorio",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Seleccionar estado menú"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {resultadoEstadosMenu}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={8}>
            <Col
              xs={{ span: 12, offset: 1 }}
              lg={{ span: 14, offset: 1 }}
              style={{ float: "left", marginTop: 0 }}
            >
              <span>
                {" "}
                {hasSelected
                  ? `Menú seleccionado: ${this.state.selectedRowsMenu[0].ID_MENU}.${this.state.selectedRowsMenu[0].NOM_MENU}`
                  : ""}
              </span>
            </Col>

            <Col xs={{ span: 12, offset: 1 }} lg={{ span: 8, offset: 1 }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  float: "right",
                  marginLeft: 20,
                  marginRight: 5,
                  marginTop: 0,
                }}
              >
                Aceptar
              </Button>

              <Button
                key="back"
                onClick={() => {
                  form.resetFields();
                }}
                style={{ float: "right", marginTop: 0 }}
              >
                Cancelar
              </Button>
            </Col>
          </Row>
        </Form>
      );
    };

    return (
      <div>
        <ConfigProvider renderEmpty={CustomizeRenderEmpty}>
          <Spin
            spinning={loadingSpingBuscarPlato}
            delay={500}
            tip={textoLoadingSpingBuscarPlato}
          >
            <div>
              <AdvancedSearchForm />

              <div id="infoBusquedaPorPlato"></div>
              <Modal
                visible={visibleModalLogoRecetasMa100}
                title="Imprimir Recetas del Menú"
                maskClosable={false}
                onOk={this.handleOkModalLogo}
                width={890}
                style={{ top: 20 }}
                onCancel={this.handleCancelModalLogo}
                footer={[
                  <Button key="back" onClick={this.handleCancelModalLogo}>
                    Cancelar
                  </Button>,
                  <Button
                    key="submit"
                    type="primary"
                    onClick={this.handleOkModalLogo}
                  >
                    Aceptar
                  </Button>,
                ]}
              >
                <p className="select-modal">
                  Debes seleccionar el logo y si quieres mostrar o no la familia
                  y la imagen de la receta. Esta acción puede tardar en
                  dependencia de la cantidad de recetas que tenga el menú.
                </p>
                <Row>
                  <Col span={8}>
                    <Select
                      showSearch
                      style={{ width: "90%" }}
                      id="selectBuscador"
                      placeholder="Seleccionar plantilla"
                      optionFilterProp="children"
                      onChange={this.onChangePlantillaReceta}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Option
                        key="1"
                        label="plantilla-recetas1"
                        value="plantilla-recetas-1"
                      >
                        Plantilla Comercial
                      </Option>
                      <Option
                        key="2"
                        label="plantilla-recetas2"
                        value="plantilla-recetas-2"
                      >
                        Plantilla Centros In Situ GV
                      </Option>
                      <Option
                        key="3"
                        label="plantilla-recetas3"
                        value="plantilla-recetas-3"
                      >
                        Plantilla Centros Transportados GV
                      </Option>
                      <Option
                        key="4"
                        label="plantilla-recetas4"
                        value="plantilla-recetas-4"
                      >
                        Plantilla Cocina Central GV
                      </Option>
                    </Select>
                  </Col>

                  <Col span={8}>
                    <Select
                      showSearch
                      style={{ width: "90%" }}
                      placeholder="Seleccionar Idioma"
                      defaultValue="525"
                      id="selectIdioma"
                      optionFilterProp="children"
                      onChange={this.onChangeIdiomas}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {resultadoIdiomas}
                    </Select>
                  </Col>

                  <Col span={8}>
                    <Select
                      showSearch
                      style={{ width: "90%" }}
                      id="selectBuscador"
                      placeholder="Seleccionar Logo"
                      optionFilterProp="children"
                      onChange={this.onChangeSelectLogo}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Option value="images/logoCompassGroup.png">
                        Compass Group
                      </Option>
                      <Option value="images/logoEurestColectividades.png">
                        Eurest Colectividades
                      </Option>
                      <Option value="images/logoEurestCatalunya.png">
                        Eurest Catalunya
                      </Option>
                      <Option value="images/logoEurestEuskadi.png">
                        Eurest Euskadi
                      </Option>
                      <Option value="images/logoEurestServices.png">
                        Eurest Services
                      </Option>
                      <Option value="images/logoMedirest.png">Medirest</Option>
                      <Option value="images/logoScolarest.png">
                        Scolarest
                      </Option>
                      <Option value="images/logoVilaplana.png">
                        Vilaplana
                      </Option>
                      <Option value="images/logoVitarest.png">Vitarest</Option>
                    </Select>
                  </Col>

                  <Col span={8}>
                    <Checkbox
                      style={{ marginTop: 15 }}
                      checked={this.state.checkboxImprimirFamiliaPlato}
                      onChange={this.onChangeCheckboxImprimirFamiliaPlato}
                    >
                      Imprimir familia.
                    </Checkbox>
                  </Col>

                  <Col span={8}>
                    <Checkbox
                      style={{ marginTop: 15 }}
                      checked={this.state.checkboxImprimirImagenPlato}
                      onChange={this.onChangeCheckboxImprimirImagenPlato}
                    >
                      Imprimir imagen.
                    </Checkbox>
                  </Col>

                  <Col span={8}>
                    <Checkbox
                      style={{ marginTop: 15 }}
                      checked={this.state.checkboxImprimirPesoPlato}
                      onChange={this.onChangeCheckboxImprimirPesoPlato}
                    >
                      Imprimir Peso Neto/Bruto.
                    </Checkbox>
                  </Col>
                </Row>
                <Title style={{ marginTop: 8 }} level={4}>
                  Listado de platos asociados al menú.
                </Title>
                <div>
                  <Row>
                    <Col span={18}>
                      <span style={{ marginLeft: 8, marginBottom: 8 }}>
                        {hasSelectedM100
                          ? `Seleccionadas ${selectedRowKeys.length} recetas`
                          : ""}
                      </span>
                    </Col>
                    <Col span={6}>
                      <Button
                        style={{ marginRight: 10, marginBottom: 8 }}
                        key="back"
                        onClick={this.handleCancelModalLogo}
                      >
                        Cancelar
                      </Button>

                      <Button
                        key="submit"
                        type="primary"
                        onClick={this.handleOkModalLogo}
                      >
                        Aceptar
                      </Button>
                    </Col>
                  </Row>

                  <Divider style={{ margin: 0 }}></Divider>
                  <Table
                    size="small"
                    rowSelection={rowSelection}
                    columns={IMPRIMIR_RECETAS_MENU_COLUMNS}
                    dataSource={dataRecetasM100}
                    pagination={{
                      position: ["topRight", "bottomRight"],
                      pageSizeOptions: ["40", "50", "60"],
                      defaultPageSize: 40,
                    }}
                  />
                </div>
              </Modal>
            </div>
          </Spin>
          <Modal
            title="Progreso Impresión Recetas"
            visible={this.state.visibleModalProgreso}
            footer={null}
            closable={false}
          >
            <Space direction="vertical">
              <p>
                El proceso de impresión puede tardar unos minutos. Depende de la
                cantidad de recetas y el peso de la imagen de la misma.
              </p>
              <Row gutter={8}>
                <Col span={24}>
                  <Progress
                    style={{ marginLeft: 170 }}
                    type="circle"
                    percent={this.state.porcientoModalProgreso}
                  />
                </Col>
              </Row>
            </Space>
          </Modal>
        </ConfigProvider>
        <BackTop />
      </div>
    );
  }
}

export default ImprimirRecetasMenu;
